import * as setup from './datatables_setup';

$(function () {
  const table = $('#file_listing_table');
  const advancedSearchContainer = document.getElementById('advanced-search-files-table');
  const dataTableOptions = {
    processing: true,
    layout: {
      topStart: 'pageLength',
      topEnd: advancedSearchContainer,
      bottomStart: 'info',
      bottomEnd: 'paging'
    },
    language: {
      lengthMenu: "Show _MENU_ entries",
      processing: '',
      emptyTable: "No data available in table",
      info: "Showing _START_ to _END_ of found entries"
    },
    serverSide: true,
    ajax: {
      url: table.data('source'),
      dataSrc: 'data'
    },
    pagingType: "simple",
    order: [[6, 'desc']],
    columnDefs: [
      { targets: 0, visible: false },
      { targets: [7, 8], orderable: false },
      { targets: [4, 5, 8], maxWidth: "140px" },
      { targets: 1, width: "25%" },
      { targets: 7, maxWidth: "200px" }
    ],
    columns: [
      null,
      null,
      null,
      { className: "text-start", type: "string" },
      { className: "text-start", type: "string" },
      { className: "text-start", type: "string" },
      null,
      { className: "text-center" },
      null
    ],
    lengthMenu: [
      [10, 25, 50, 100],
      [10, 25, 50, 100]
    ],
    preDrawCallback: function () {
      const show_accounts = $('#file_listing_table').hasClass('show-accounts');
      $('#file_listing_table').DataTable().column(0).visible(show_accounts);
      setup.tableStartProcessing();
    },
    drawCallback: function () {
      setup.tableStopProcessing();
      document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {
        new bootstrap.Popover(el, { sanitize: false });
      });
      document.querySelectorAll('[data-bs-toggle="tooltip"], [data-bs-toggle-tooltip="tooltip"]').forEach(el => {
        new bootstrap.Tooltip(el);
      });
    },
  };

  let fileListingTable = table.DataTable(dataTableOptions);

  $('.dropdown-menu-file-listing').on('click', function (e) {
    e.stopPropagation();
  });

  // Move to the first page after user changes par page option
  table.on('length.dt', function (e) {
    fileListingTable.page(0);
  })



  $('#search-inp').on('keyup', function (e) {
    if (e.code == 'Enter') {
      generalSearch();
    }
  });
  $('#search-files-table-btn').on('click', function () {
    generalSearch();
  });
  $('#advanced-search-files-table-btn').on('click', function (e) {
    e.preventDefault();
    advancedSearch();
  });
  $('#refresh-table-btn').on('click', function () {
    // datatables provides an inbuilt way to refresh the table
    fileListingTable.ajax.reload();
  });

  function accountNameSearch(accountNameInput = $('#account_name').val()) {
    fileListingTable.columns(0).search(accountNameInput).draw();
  }
  function pmpSearch(pmpSelectInput = $('.search-pmp-select').children("option:selected").val()) {
    fileListingTable.columns(2).search(pmpSelectInput).draw();
  }
  function submissionBeginDateSearch(beginDateInput = $('#submission_begin_date').val()) {
    fileListingTable.columns(6).search(beginDateInput).draw();
  }
  function submissionEndDateSearch(endDateInput = $('#submission_end_date').val()) {
    fileListingTable.columns(7).search(endDateInput).draw();
  }
  function generalSearch(searchInput = $('#search-inp').val()) {
    if (fileListingTable == null || fileListingTable == undefined) return;
    return fileListingTable.search(searchInput).draw()
  };
  function advancedSearch() {
    const fileNameInput = $('#file_name').val()

    if (fileListingTable == null || fileListingTable == undefined) return;

    pmpSearch();
    submissionBeginDateSearch();
    submissionEndDateSearch();
    accountNameSearch();
    generalSearch(fileNameInput);
  };
});

$(window).on('load', function () {
  let table_filter = $('#file_listing_table_filter');
  $('#refresh-table-btn').parent().insertBefore(table_filter)

  const refreshBtn = document.getElementById('refresh-table-btn');
  if (refreshBtn) {
    new bootstrap.Tooltip(refreshBtn, { trigger: 'hover', delay: { "hide": 1 } });
  }

  let timer;
  $(document).on("mouseover", "#refresh-table-btn", function () {

    timer = setTimeout(function () {
      if (refreshBtn) bootstrap.Tooltip.getInstance(refreshBtn).hide();
    }, 2000);
  });

  $(document).on("mouseout", "#refresh-table-btn", function () {
    clearTimeout(timer);
  });
});
